import React from 'react';
// Import the banner image verbatim
import MainHome from '../../assets/images/MainHome.jpeg'; 

const SansmrutiHome = () => {
    return (
        <div style={{ width: '100%', margin: '0', padding: '0', overflowX: 'hidden' }}>
            
            {/* Banner Container with Margin for Distance */}
            <div style={{ 
                width: '100%', 
                height: 'calc(100vh - 80px)', // Adjust 80px based on your actual navbar height
                marginTop: '20px',           // This adds the distance between navbar and image
                overflow: 'hidden' 
            }}>
                <img 
                    src={MainHome} 
                    alt="Sansmruti Publication Banner" 
                    style={{ 
                        width: '100%', 
                        height: '100%', 
                        objectFit: 'contain', 
                        display: 'block' 
                    }} 
                />
            </div>

            {/* Title Section */}
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <h1 style={{ fontSize: '2rem', color: '#333', margin: '0' }}>
                    Sansmruthi Publication Home
                </h1>
            </div>
        </div>
    );
}

export default SansmrutiHome;